/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  share.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:31
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

/* 分享模块 */
import ShareHomeLayout from "@/layouts/ShareHomeLayout.vue";

const shareRouter = [
  {
    path: "/shareHomeLayout",
    component: ShareHomeLayout,
    hidden: true,
    children: [
      {
        path: "/shareGoodsDetail",
        name: "ShareGoodsDetail",
        component: () =>
            import(/* webpackChunkName: "share" */ "@/views/share/ShareGoodsDetail.vue"),
        meta: {
          title: "分享商品",
          deepth: 1
        },
      },
      {
        path: "/shareGoodsList",
        name: "ShareGoodsList",
        component: () =>
            import(/* webpackChunkName: "share" */ "@/views/share/ShareGoodsList.vue"),
        meta: {
          title: "全部商品",
          keepAlive: true,
          deepth: 1
        },
      },
      {
        path: "/shareService",
        name: "ShareService",
        component: () =>
            import(/* webpackChunkName: "share" */ "@/views/share/ShareService.vue"),
        meta: {
          title: "联系企业",
          keepAlive: true,
          deepth: 1
        },
      },
    ]
  },
  {
    path: "/shareGoodsListDetail",
    name: "ShareGoodsListDetail",
    component: () =>
        import(/* webpackChunkName: "share" */ "@/views/share/ShareGoodsListDetail.vue"),
    meta: {
      title: "商品详情",
      deepth: 2
    },
  },
  {
    path: "/shareRegister",
    name: "ShareRegister",
    component: () =>
        import(/* webpackChunkName: "share" */ "@/views/share/ShareRegister.vue"),
    meta: {
      title: "注册",
      deepth: 2
    },
  },
  {
    path: "/shareLogin",
    name: "ShareLogin",
    component: () =>
        import(/* webpackChunkName: "share" */ "@/views/share/ShareLogin.vue"),
    meta: {
      title: "登录",
      deepth: 2
    },
  },
]

export default shareRouter
